<template>
  <div>
    <b-alert v-if="staleError" variant="warning" show dismissible @dismissed="staleError = false">
      Der Lagerbestand wurde zwischenzeitlich geändert. Bitte erneut speichern.
    </b-alert>
    <b-form inline class="mb-3 col-md-9 pl-0">
      <div class="col pl-0">
        <label v-if="variantIndex===0">Name</label>
        {{variant.title}}
      </div>
      <div class="col" style="max-width: 120px">
        <variant-list-input name="Anzahl" :index="variantIndex" type="number" v-model="quantity"></variant-list-input>
      </div>
      <div class="col">
        <b-button :disabled="!isDirty" :variant="isDirty ? 'primary' : 'secondary'" @click="update">Speichern
          <b-spinner v-if="inProgress" small></b-spinner>
        </b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import VariantListInput from "@/pages/EditProductPage/Variants/VariantListInput";
import inventory from "@/api/inventory";
export default {
  inject: ['showSuccessAlert'],
  props: ['variant', 'variantIndex'],
  components: {VariantListInput},
  data(){
    return {
      quantity: 0,
      savedQuantity: 0,
      inProgress: false,
      staleError: false
    }
  },
  created() {
    this.savedQuantity = this.inventoryLevel.quantities[0].quantity;
    this.quantity = this.savedQuantity;
  },
  watch: {
    variant() {
      this.savedQuantity = this.inventoryLevel.quantities[0].quantity;
    }
  },
  computed:{
    inventoryLevel() {
      return this.variant.inventoryItem.inventoryLevels[0];
    },
    isDirty() {
      return this.quantity !== this.savedQuantity;
    }
  },
  methods: {
    update() {
      if (this.isDirty) {
        this.inProgress = true;
        inventory.update(
            this.variant.product.id,
            this.variant.inventoryItem.id,
            this.quantity,
            this.savedQuantity,
            this.inventoryLevel.location.id
        ).then(() => {
              this.savedQuantity = this.quantity;
              this.showSuccessAlert("Änderung ist gespeichert");
            }
        ).catch((error) => {
            const errors = error?.response?.data?.message;
            const isStale = errors?.some(e => e.field?.includes('changeFromQuantity'));
            if (isStale) {
              this.staleError = true;
              this.$store.dispatch('products/fetchProduct', { productId: this.$route.params.id })
            } else {
              this.$bvModal.show('error-modal')
            }
        }).finally(() => {
            this.inProgress = false
        })
      }
    }
  }
}
</script>
